module.exports = __webpack_public_path__ + "./assets/img/portfolio_2.a660b305.jpg";